import { render, staticRenderFns } from "./uploaddownbomexcel.vue?vue&type=template&id=6f28dff6"
import script from "./uploaddownbomexcel.vue?vue&type=script&lang=js"
export * from "./uploaddownbomexcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports